(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9396],{

/***/ 94217:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(10712);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_meta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59409);
/* harmony import */ var _screens_embeded_pdf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39145);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90644);








function PrivacyPolicyPage(props) {
    var metaInfo = props.metaInfo, url = props.url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, metaInfo), {
                title: "Pol\xedtica de Privacidad",
                noRobots: true
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_screens_embeded_pdf__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                url: url
            })
        ]
    });
}
PrivacyPolicyPage.getInitialProps = function(context) {
    var res = context.res;
    var privacyPolicyUrl = context.vendor.privacyPolicyUrl;
    if (!privacyPolicyUrl) {
        (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .redirectTo */ .gB)("/", context);
        return;
    }
    if ((0,lodash__WEBPACK_IMPORTED_MODULE_2__.includes)(privacyPolicyUrl, "cloudinary")) {
        return {
            url: privacyPolicyUrl,
            metaInfo: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .getMetaInfo */ .R7)(context)
        };
    }
    if (res) {
        res.redirect(privacyPolicyUrl);
    } else if (true) {
        window.location.href = privacyPolicyUrl;
    }
};
/* harmony default export */ __webpack_exports__["default"] = (PrivacyPolicyPage);


/***/ }),

/***/ 39145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
// Google Docs pdf embed workaround based on https://stackoverflow.com/a/61451002


var EmbededPdfScreen = function(props) {
    var url = props.url;
    var timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var iframeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var source = "https://docs.google.com/gview?embedded=true&url=".concat(url);
    var setIframeSource = function() {
        if (iframeRef.current) {
            iframeRef.current.src = source;
        }
    };
    var onIframeLoad = function() {
        var ref, ref1;
        var contentLoaded = (ref = iframeRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : ref1.length;
        if (contentLoaded) {
            clearInterval(timeoutRef.current);
            return;
        }
        setIframeSource();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // 3 seconds is an arbitrary value to expect the iframe content to load
        timeoutRef.current = setInterval(setIframeSource, 1000 * 3);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            overflow: "hidden",
            height: "100vh"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            title: "preview document",
            src: source,
            width: "100%",
            height: "100%",
            ref: iframeRef,
            onError: setIframeSource,
            onLoad: onIframeLoad
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmbededPdfScreen);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(49484), __webpack_exec__(94217); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);